import { render, staticRenderFns } from "./get-distance.vue?vue&type=template&id=54f89612&scoped=true"
import script from "./get-distance.vue?vue&type=script&lang=js"
export * from "./get-distance.vue?vue&type=script&lang=js"
import style0 from "./get-distance.vue?vue&type=style&index=0&id=54f89612&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f89612",
  null
  
)

export default component.exports